import { MatPaginatorIntl } from '@angular/material/paginator';

export class PaginatorCustom extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Elementi per pagina';

  override nextPageLabel = 'Pagina successiva';

  override previousPageLabel = 'Pagina precedente';

  override firstPageLabel = 'Prima pagina';

  override lastPageLabel = 'Ultima pagina';

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0) {
      return `0 di ${length}`;
    }

    const start = page * pageSize + 1;

    const end = Math.min((page + 1) * pageSize, length);

    return `${start} - ${end} di ${length}`;
  };
}
